module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_3-79838e30cedd9c2a44da7ae391477176.svg";